import React, { useEffect, useState } from "react";
import { CgEye } from "react-icons/cg";
import {
  DocCancelIcon,
  Docdownload,
  Upwardarrow,
  ViewIcon,
  ViewsIcons,
} from "../../../../../utility/constants/assetsManager";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import CustomUploadField2 from "../../../../components/ui_comps/CustomUploadField2";

const DocumentComponent = ({
  label,
  value,
  isEditClicked,
  onChange,
  imageTypeArray = ["pdf"],
  accept = ".pdf",
}) => {
  const getNameFromUrl = (url) => {
    if (url) {
      return decodeURIComponent(url.split("/").pop());
    }
  };

  return (
    <div style={{ marginTop: 20 }}>
      <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
        {label}
      </label>

      {isEditClicked ? (
        <CustomUploadField2
          document={label}
          customIcon={<Upwardarrow />}
          value={value}
          onChange={(data) => {
            onChange(data);
          }}
          onClickRemove={() => {
            onChange("");
          }}
          filesize={10}
          style={{
            width: "350px",
            height: "40px",
            border: "1px solid #CBCACA",
            background: "white",
            maxWidth: "350px",
            padding: "0px 10px",
            marginBottom: "0px",
          }}
          containerStyle={{
            height: "40px",
            padding: "0px",
          }}
          textStyles={{
            fontSize: 13,
            color: "#697D95",
          }}
          imageTypeArray={imageTypeArray}
          accept={accept}
        />
      ) : (
        <div
          style={{
            width: "350px",
            height: "40px",
            border: "1px solid #CBCACA",
            borderRadius: 5,
            fontSize: 13,
            color: "#697D95",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0px 10px",
          }}
        >
          <div>
            {" "}
            {getNameFromUrl(value)?.length > 15
              ? getNameFromUrl(value)?.slice(0, 15) + "..."
              : getNameFromUrl(value)}
          </div>
          <div
            style={{
              width: 80,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
            }}
          >
            <a
              href={value}
              download
              color="transparent"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Docdownload />
            </a>
            <a
              href={value}
              color="transparent"
              target="_blank"
              rel="noopener noreferrer"
            >
              <ViewsIcons />
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

function Documents({ clientData, onChange, isEditClicked }) {
  const [panCardUrl, setPanCardUrl] = useState("");
  const [aadharUrl, setAadharUrl] = useState("");
  const [
    shopAndEstablishmentCertificateUrl,
    setShopAndEstablishmentCertificateUrl,
  ] = useState("");
  const [udyogCertificateUrl, setUdyogCertificateUrl] = useState("");
  const [uploadSignedSlaUrl, setUploadSignedSlaUrl] = useState("");
  const [ndaCertificateUrl, setNdaCertificateUrl] = useState("");
  const [others, setOthers] = useState("");
  const [gstCertificateUrl, setGstCertificateUrl] = useState("");
  const [incorporationCertificateUrl, setIncorporationCertificateUrl] =
    useState("");
  const [cancelledChequeUrl, setCancelledChequeUrl] = useState("");
  const [kycSigningAuthorityUrl, setKycSigningAuthorityUrl] = useState("");
  const [memorandumOfAssociationUrl, setMemorandumOfAssociationUrl] =
    useState("");
  const [articleOfAssociationUrl, setArticleOfAssociationUrl] = useState("");
  const [merchantApprovalFormUrl, setMerchantApprovalFormUrl] = useState("");
  const [partnershipDeedsUrl, setPartnershipDeedsUrl] = useState("");

  const [agreementUrl, setAgreementUrl] = useState("");
  const [merchantOnboardingUrl, setMerchantOnboardingUrl] = useState("");
  const [upiRequestForm, setUpiRequestForm] = useState("");

  useEffect(() => {
    if (isEditClicked) {
      setPanCardUrl("");
      setAadharUrl("");
      setShopAndEstablishmentCertificateUrl("");
      setUdyogCertificateUrl("");
      setUploadSignedSlaUrl("");
      setNdaCertificateUrl("");
      setOthers("");
      setGstCertificateUrl("");
      setIncorporationCertificateUrl("");
      setCancelledChequeUrl("");
      setKycSigningAuthorityUrl("");
      setMemorandumOfAssociationUrl("");
      setArticleOfAssociationUrl("");
      setMerchantApprovalFormUrl("");
      setPartnershipDeedsUrl("");
      setAgreementUrl("");
      setMerchantOnboardingUrl("");
      setUpiRequestForm("");
    } else {
      setPanCardUrl(clientData?.panCardUrl);
      setAadharUrl(clientData?.aadharUrl);
      setShopAndEstablishmentCertificateUrl(
        clientData?.shopAndEstablishmentCertificateUrl
      );
      setUdyogCertificateUrl(clientData?.udyogCertificateUrl);
      setUploadSignedSlaUrl(clientData?.uploadSignedSlaUrl);
      setNdaCertificateUrl(clientData?.ndaCertificateUrl);
      setOthers(clientData?.others);
      setGstCertificateUrl(clientData?.gstCertificateUrl);
      setIncorporationCertificateUrl(clientData?.incorporationCertificateUrl);
      setCancelledChequeUrl(clientData?.cancelledChequeUrl);
      setKycSigningAuthorityUrl(clientData?.kycSigningAuthorityUrl);
      setMemorandumOfAssociationUrl(clientData?.memorandumOfAssociationUrl);
      setArticleOfAssociationUrl(clientData?.articleOfAssociationUrl);
      setMerchantApprovalFormUrl(clientData?.merchantApprovalFormUrl);
      setPartnershipDeedsUrl(clientData?.partnershipDeedsUrl);
      setAgreementUrl(clientData?.agreementUrl);
      setMerchantOnboardingUrl(clientData?.merchantOnboardingUrl);
      setUpiRequestForm(clientData?.upiRequestForm);
    }
  }, [isEditClicked]);

  useEffect(() => {
    if (isEditClicked) {
      onChange({
        panCardUrl,
        aadharUrl,
        shopAndEstablishmentCertificateUrl,
        udyogCertificateUrl,
        uploadSignedSlaUrl,
        ndaCertificateUrl,
        others,
        gstCertificateUrl,
        incorporationCertificateUrl,
        cancelledChequeUrl,
        kycSigningAuthorityUrl,
        memorandumOfAssociationUrl,
        articleOfAssociationUrl,
        merchantApprovalFormUrl,
        partnershipDeedsUrl,
        agreementUrl,
        merchantOnboardingUrl,
        upiRequestForm,
      });
    }
  }, [
    panCardUrl,
    aadharUrl,
    shopAndEstablishmentCertificateUrl,
    udyogCertificateUrl,
    uploadSignedSlaUrl,
    ndaCertificateUrl,
    others,
    gstCertificateUrl,
    incorporationCertificateUrl,
    cancelledChequeUrl,
    kycSigningAuthorityUrl,
    memorandumOfAssociationUrl,
    articleOfAssociationUrl,
    merchantApprovalFormUrl,
    partnershipDeedsUrl,
    agreementUrl,
    merchantOnboardingUrl,
    upiRequestForm,
    isEditClicked,
  ]);

  return (
    <div>
      <div
        style={{
          marginLeft: "2%",
          display: "flex",
          flexWrap: "wrap",
          gap: "0px 100px",
        }}
      >
        <DocumentComponent
          label={"Upload PAN card"}
          value={panCardUrl}
          onChange={(data) => setPanCardUrl(data)}
          isEditClicked={isEditClicked}
        />

        <DocumentComponent
          label={"Upload Signed SLA"}
          value={uploadSignedSlaUrl}
          onChange={(data) => setUploadSignedSlaUrl(data)}
          isEditClicked={isEditClicked}
        />

        <DocumentComponent
          label={"Upload NDA Certificate"}
          value={ndaCertificateUrl}
          onChange={(data) => setNdaCertificateUrl(data)}
          isEditClicked={isEditClicked}
        />

        <DocumentComponent
          label={"Upload Cancelled Cheque"}
          value={cancelledChequeUrl}
          onChange={(data) => setCancelledChequeUrl(data)}
          isEditClicked={isEditClicked}
        />

        <DocumentComponent
          label={"Upload Onboarding Docs(UPI)"}
          value={upiRequestForm}
          onChange={(data) => setUpiRequestForm(data)}
          isEditClicked={isEditClicked}
          imageTypeArray={["xlsx"]}
          accept=".xlsx"
        />

        {(clientData?.businessType === "SoleProprietorship" ||
          clientData?.businessType === "Partnership") && (
          <>
            <DocumentComponent
              label={"Upload Udyog Aadhar/ Udyam Aadhar"}
              value={udyogCertificateUrl}
              onChange={(data) => setUdyogCertificateUrl(data)}
              isEditClicked={isEditClicked}
            />
            <DocumentComponent
              label={"Upload Aadhar"}
              value={aadharUrl}
              onChange={(data) => setAadharUrl(data)}
              isEditClicked={isEditClicked}
            />
            <DocumentComponent
              label={"Upload Shop Establishment Certificate"}
              value={shopAndEstablishmentCertificateUrl}
              onChange={(data) => setShopAndEstablishmentCertificateUrl(data)}
              isEditClicked={isEditClicked}
            />

            <DocumentComponent
              label={"Upload Agreement"}
              value={agreementUrl}
              onChange={(data) => setAgreementUrl(data)}
              isEditClicked={isEditClicked}
            />

            <DocumentComponent
              label={"Upload Merchant Onboarding"}
              value={merchantOnboardingUrl}
              onChange={(data) => setMerchantOnboardingUrl(data)}
              isEditClicked={isEditClicked}
            />

            {clientData?.others && (
              <DocumentComponent
                label={"Upload Others"}
                value={others}
                onChange={(data) => setOthers(data)}
                isEditClicked={isEditClicked}
              />
            )}
          </>
        )}

        {clientData?.businessType === "Partnership" && (
          <DocumentComponent
            label={"Upload Partnership deeds"}
            value={partnershipDeedsUrl}
            onChange={(data) => setPartnershipDeedsUrl(data)}
            isEditClicked={isEditClicked}
          />
        )}

        {(clientData?.businessType === "Public" ||
          clientData?.businessType === "PrivateLimited") && (
          <>
            <DocumentComponent
              label={"Upload Merchant Approval Form"}
              value={merchantApprovalFormUrl}
              onChange={(data) => setMerchantApprovalFormUrl(data)}
              isEditClicked={isEditClicked}
            />
            <DocumentComponent
              label={"Upload GST Certificate"}
              value={gstCertificateUrl}
              onChange={(data) => setGstCertificateUrl(data)}
              isEditClicked={isEditClicked}
            />

            <DocumentComponent
              label={"Upload COI Certificate"}
              value={incorporationCertificateUrl}
              onChange={(data) => setIncorporationCertificateUrl(data)}
              isEditClicked={isEditClicked}
            />

            <DocumentComponent
              label={"Upload Memorandum of Association"}
              value={memorandumOfAssociationUrl}
              onChange={(data) => setMemorandumOfAssociationUrl(data)}
              isEditClicked={isEditClicked}
            />

            <DocumentComponent
              label={"Upload KYC of the Signing authority"}
              value={kycSigningAuthorityUrl}
              onChange={(data) => setKycSigningAuthorityUrl(data)}
              isEditClicked={isEditClicked}
            />

            <DocumentComponent
              label={"Upload Article of Association"}
              value={articleOfAssociationUrl}
              onChange={(data) => setArticleOfAssociationUrl(data)}
              isEditClicked={isEditClicked}
            />
          </>
        )}
      </div>
    </div>
  );
}

export default Documents;
